import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import  {Inject, Injectable} from '@angular/core';
import { Observable } from 'rxjs';
import { StorageService } from '../services/storage.service';

@Injectable()

export class TokenInterceptor implements HttpInterceptor{
 
    constructor (private readonly storage :StorageService){}

     intercept (
         req: HttpRequest<any>,
         next: HttpHandler
         ):Observable<HttpEvent<any>>{

            if (req.url.includes('/auth')){
                 return next.handle(req);
            }
        const accessToken= this.storage.get('accessToken');
         // alert(accessToken);
        const requestClone= req.clone({
        headers: req.headers.append("Authorization",`Bearer ${accessToken}`),

        });

       return next.handle(requestClone);

    }

}

